import { useState, useEffect } from "react";
import type { Persona } from "@macroscope/shared";
import { DEFAULT_PERSONA } from "@macroscope/shared";

const STORAGE_KEY = "macroscope_persona";

export function usePersona(): [Persona, (p: Persona) => void] {
  const [persona, setPersonaState] = useState<Persona>(() => {
    if (typeof window === "undefined") return DEFAULT_PERSONA;
    return (window.localStorage.getItem(STORAGE_KEY) as Persona | null) ?? DEFAULT_PERSONA;
  });

  useEffect(() => {
    window.localStorage.setItem(STORAGE_KEY, persona);
  }, [persona]);

  return [persona, setPersonaState];
}
